import { Typography } from '@mui/material'
import { SCommentContainer } from '../styles/events.styled'

export const EventComment = ({ comment }: { comment: string }) => {
  return (
    <SCommentContainer>
      <Typography color="white" align="center" fontSize={12} style={{ fontStyle: 'italic' }}>
        {comment}
      </Typography>
    </SCommentContainer>
  )
}
